import RWStorage from '@advisor/util/common/storage';
import Auth from '@advisor/models/store/auth';
import {logout} from '@simpleinvest/front-end-auth';
import {ENTERPRISE_FEATURES, SSO_REDIRECT_URI} from '@advisor/util/constants';
import exceptionHandler from '@advisor/util/exceptionHandler';

export const stateObj = () => new Auth();

export const getters = {};

export const actions = {
  // eslint-disable-next-line no-unused-vars
  async logout({rootState}, {timeout = false} = {}) {
    try {
      await logout();
    } catch (error) {
      exceptionHandler.handleGenericException('auth.logout', error);
    } finally {
      RWStorage.clear();
      sessionStorage.clear();
      const enterpriseFeatures = rootState.settings.enterprise.features;

      const hasSSOFeature = enterpriseFeatures.includes(ENTERPRISE_FEATURES.SSO);

      let replaceUrl = window.BASE_URL;

      // use a browser load to redirect to the Login page
      replaceUrl = replaceUrl.replace(/\/?$/, '/');

      // For enterprise with SSO feature enabled, redirect to {url}/portal/advisorlogin
      if (hasSSOFeature) {
        replaceUrl += SSO_REDIRECT_URI;
      }

      if (timeout) {
        replaceUrl += '?inactive=true';
      }

      window.location.replace(replaceUrl);
    }
  },
};

const mutations = {};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
